export function createMaterialAlmacen() {
  return {
    MaterialClave: '',
    AlmacenClave: '',
    EmpresaId: 0,
    EnStock: 0,
    Comprometido: 0,
    Pedido: 0
  };
}
